import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Contenido } from 'src/common/contenido';
import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { detalleSelected, detalleReady } from '../store/detalle/detalle.selectors';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { detalleCleared } from '../store/detalle/detalle.actions';

@Component({
	selector: 'detalle',
	templateUrl: './detalle.component.html',
	styleUrls: ['./detalle.component.scss'],
	encapsulation: ViewEncapsulation.None	// para poder tener reglas css en el html del detalle
})
export class DetalleComponent implements OnInit, OnDestroy {

	public detalle$: Observable<Contenido>;
	public ready$: Observable<boolean>;

	constructor( private store: Store<AppState>, private sanitizer: DomSanitizer ) {
	}

	ngOnInit() {
		this.detalle$ = this.store.select( detalleSelected )
			.pipe(
				map( detalle => { return { ...detalle, html: this.sanitizer.bypassSecurityTrustHtml( detalle.detalle ) } } )
			);
		this.ready$ = this.store.select( detalleReady );
	}

	ngOnDestroy(): void {
		this.store.dispatch( detalleCleared() );
	}

}
